var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgIconEditReplicate = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0V16H16V5.65723L13.375 8.28223V13.375H2.625V2.625H7.71777L10.3428 0H0ZM14 0L12.9756 1.02441L14.9756 3.02441L16 2L14 0ZM12.4922 1.50781L6.62891 7.37109L8.62891 9.37109L14.4922 3.50781L12.4922 1.50781ZM5.89257 8.29785C5.86291 8.29831 5.83267 8.30045 5.80273 8.30273V10.1973H7.69727C7.69727 9.68116 7.45071 9.15675 7.06641 8.79004C6.74852 8.48669 6.33741 8.291 5.89257 8.29785Z",
    fill: "#C2121F"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconEditReplicate, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_edit_replicate.6cc9d662.svg";
export { ForwardRef as ReactComponent };